var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 48.5,
    height: 48.5,
    rx: 11.75,
    fill: "#151C32",
    stroke: "#4E5567",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6648 32.8057C26.1267 32.9193 25.5689 32.9794 24.9974 32.9794C20.5704 32.9794 16.9766 29.3856 16.9766 24.9585C16.9766 24.579 16.6686 24.271 16.2891 24.271C15.9096 24.271 15.6016 24.579 15.6016 24.9585C15.6016 30.1441 19.8118 34.3544 24.9974 34.3544C25.6666 34.3544 26.3197 34.2842 26.9494 34.1509C27.3207 34.072 27.5586 33.7072 27.4797 33.336C27.4014 32.9647 27.0361 32.7268 26.6648 32.8057ZM26.1272 17.0165C30.0198 17.5661 33.0182 20.9151 33.0182 24.9585C33.0182 27.8185 31.5176 30.3311 29.2622 31.7515C28.9409 31.9536 28.8446 32.3785 29.0468 32.6993C29.2489 33.0206 29.6738 33.1169 29.9946 32.9148C32.6369 31.2515 34.3932 28.3085 34.3932 24.9585C34.3932 20.2217 30.8796 16.2988 26.3192 15.6553C25.9434 15.6021 25.5955 15.8643 25.5424 16.2397C25.4892 16.6155 25.7514 16.9638 26.1272 17.0165ZM17.5541 21.9665C18.4134 19.833 20.1638 18.1527 22.3432 17.3878C22.7016 17.2622 22.89 16.8694 22.7644 16.5115C22.6388 16.1535 22.246 15.9647 21.8881 16.0902C19.3352 16.9863 17.285 18.9544 16.2785 21.4527C16.1369 21.8047 16.3074 22.2058 16.6594 22.3474C17.0114 22.4895 17.412 22.3185 17.5541 21.9665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/Status.58f27565da9c2f9afaa2e28a905fb4da.svg";
export { ForwardRef as ReactComponent };